import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const CATEGORY_IMAGES: Record<string, string> = {
  'access-tutorial': 'https://readdy.ai/api/search-image?query=Modern%20laptop%20on%20a%20clean%20wooden%20desk%20displaying%20a%20step-by-step%20guide%20interface%2C%20warm%20ambient%20lighting%20from%20window%2C%20minimalist%20workspace%20with%20a%20small%20plant%2C%20editorial%20photography%20style%2C%20soft%20warm%20cream%20tones&width=800&height=600&seq=cat-access-tutorial&orientation=landscape',
  'faq-solutions': 'https://readdy.ai/api/search-image?query=A%20person%20troubleshooting%20on%20laptop%20with%20search%20interface%20displayed%2C%20warm%20modern%20office%20setting%2C%20soft%20natural%20light%2C%20clean%20minimalist%20desk%2C%20warm%20beige%20and%20cream%20color%20palette%2C%20professional%20atmosphere&width=800&height=600&seq=cat-faq&orientation=landscape',
  'latest-news': 'https://readdy.ai/api/search-image?query=Digital%20news%20and%20updates%20displayed%20on%20a%20sleek%20tablet%20screen%2C%20modern%20minimalist%20workspace%2C%20warm%20ambient%20lighting%2C%20clean%20aesthetic%2C%20soft%20cream%20and%20beige%20tones%2C%20editorial%20style&width=800&height=600&seq=cat-news&orientation=landscape',
  'usage-tips': 'https://readdy.ai/api/search-image?query=Productivity%20workspace%20with%20laptop%20showing%20tips%20and%20tricks%20interface%2C%20warm%20natural%20light%20from%20window%2C%20clean%20minimalist%20desk%20with%20coffee%20and%20notebook%2C%20soft%20beige%20and%20cream%20tones%2C%20editorial%20photography&width=800&height=600&seq=cat-tips&orientation=landscape',
  'account-security': 'https://readdy.ai/api/search-image?query=Digital%20security%20concept%20with%20shield%20icon%20on%20laptop%20screen%2C%20modern%20clean%20workspace%2C%20warm%20ambient%20lighting%2C%20professional%20atmosphere%2C%20soft%20cream%20and%20beige%20tones%2C%20editorial%20photography&width=800&height=600&seq=cat-security&orientation=landscape',
  'platform-guide': 'https://readdy.ai/api/search-image?query=Comprehensive%20digital%20guide%20displayed%20on%20a%20large%20monitor%2C%20organized%20dashboard%20interface%2C%20modern%20creative%20workspace%2C%20warm%20natural%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20soft%20beige%20tones&width=800&height=600&seq=cat-guide&orientation=landscape',
};

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            内容分类导航
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto">
            按主题分类浏览，快速找到您需要的教程和解答
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={CATEGORY_IMAGES[cat.slug]}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute top-3 right-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs text-foreground-700">
                  {cat.count} 篇文章
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                    <i className={`${cat.icon} text-sm`}></i>
                  </div>
                  <h3 className="text-base font-heading text-foreground-900">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}